import { render } from "./SaleForm.vue?vue&type=template&id=2bf01a23&scoped=true"
import script from "./SaleForm.vue?vue&type=script&lang=ts"
export * from "./SaleForm.vue?vue&type=script&lang=ts"

import "./SaleForm.vue?vue&type=style&index=0&id=2bf01a23&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bf01a23"

export default script